import {ResourcesLoader} from '@fantasmagames/core/src/loader/ResourcesLoader';
import {GameSystem} from 'src/GameSystem';
import {RecodeCurrencyFormatter} from '@fantasmagames/core/src/utils/RecodeCurrencyFormatter';
import {CurrencyFormatter} from '@fantasmagames/core/src/utils/CurrencyFormatter';
import {GameResourceLoader} from './GameResourceLoader';

export class RecodeGameSystem extends GameSystem {
	protected getLocale(): string {
		const lang: string = (window as any).V.API.Core.getCasinoState().lang;

		return lang.toLowerCase();
	}
	protected createResourceLoader(getBaseUrlPath: Function): ResourcesLoader {
		return new GameResourceLoader(this.device, getBaseUrlPath, this.getLocale(), this._majorCaveatPerformance);
	}

	protected createCurrencyFormatter(): CurrencyFormatter {
		return new RecodeCurrencyFormatter();
	}

	protected getCurrencyISO(): string {
		let isoCode = (window as any).V.API.Core.getCasinoState().player.currencyIsoCode;

		if (!__PRODUCTION__) {
			if (this._urlParams.customISO) {
				isoCode = this._urlParams.customISO;
				if (this._currencyFormatter) {
					(this._currencyFormatter as any).setCurrencyData(
						(this._currencyFormatter as any).parseCurrencyFormatting(
							isoCode,
							CurrencyFormatter.CurrenciesDisplayFormat[isoCode],
						),
					);
				}
			}
		}

		return isoCode;
	}
}



// WEBPACK FOOTER //
// ./src/RecodeGameSystem.ts